import { render } from "./DeleteBlackSvg.vue?vue&type=template&id=2e1afc76"
import script from "./DeleteBlackSvg.vue?vue&type=script&lang=js"
export * from "./DeleteBlackSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__